import styled from 'styled-components';

export const RelativeContainer = styled.div`
    position: relative;
`;
